import * as tslib_1 from "tslib";
import { ElemForm } from './../elem';
var SvgForm = (function (_super) {
    tslib_1.__extends(SvgForm, _super);
    function SvgForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SvgForm.prototype.materializeViewParam = function (view, param, stack, factory) {
        return _super.prototype.materializeViewParam.call(this, view, param, stack, factory);
    };
    SvgForm.prototype.materializeModelParam = function (model, param, stack, factory) {
        return _super.prototype.materializeModelParam.call(this, model, param, stack, factory);
    };
    return SvgForm;
}(ElemForm));
export { SvgForm };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3ZnLWZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdmctZm9ybS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBSUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLFdBQVcsQ0FBQztBQUluQztJQUFrRyxtQ0FBYztJQUFoSDs7SUFRQSxDQUFDO0lBUEMsc0NBQW9CLEdBQXBCLFVBQXFCLElBQU8sRUFBRSxLQUFXLEVBQUUsS0FBZ0IsRUFBRSxPQUFlO1FBQzFFLE1BQU0sQ0FBQyxpQkFBTSxvQkFBb0IsWUFBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBRUQsdUNBQXFCLEdBQXJCLFVBQXNCLEtBQVEsRUFBRSxLQUFXLEVBQUUsS0FBZ0IsRUFBRSxPQUFlO1FBQzVFLE1BQU0sQ0FBQyxpQkFBTSxxQkFBcUIsWUFBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQztJQUNuRSxDQUFDO0lBQ0gsY0FBQztBQUFELENBQUMsQUFSRCxDQUFrRyxRQUFRLEdBUXpHIn0=